// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__2i9qs","title":"styles_title__3B_JJ"};